import * as React from 'react';

export default function PanelRow({label, value}) {
	return (
		<div className="border-b last:border-b-0 border-gray-200 grid md:grid-cols-[180px_1fr] py-2 md:py-0 text-left text-xs hover:bg-gray-50 transition-colors">
			<div className="px-6 md:py-2 text-gray-600">{label}</div>
			<div className="px-6 md:py-2 w-full">{value}</div>
		</div>
	);
}
